(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hy-grids"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hy-grids')) {
  class HyGrids extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.raf = 0;

      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      this.onClick = (e) => {
        const btn = e.target.closest('[data-dir]');
        if (btn) this.go(Number(btn.dataset.dir), false);
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('click', this.onClick);
      this.ro = new ResizeObserver(this.onScroll);
      this.ro.observe(this.track);

      this.setupAutoplay();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      this.ro && this.ro.disconnect();
      this.io && this.io.disconnect();
      clearInterval(this.timer);
    }

    isSlider() {
      return getComputedStyle(this.track).overflowX !== 'visible';
    }

    step() {
      const item = this.track.querySelector('[data-item]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    }

    go(dir, loop) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (loop && dir > 0 && t.scrollLeft >= max - 2) {
        t.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        t.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const scrollable = this.isSlider() && max > 2;
      this.toggleAttribute('data-scrollable', scrollable);
      if (!scrollable) return;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      this.style.setProperty('--hy-thumb', (t.clientWidth / t.scrollWidth).toFixed(4));
      this.style.setProperty('--hy-progress', (t.scrollLeft / max).toFixed(4));
    }

    setupAutoplay() {
      const ms = Number(this.dataset.autoplay);
      if (!ms || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.paused = false;
      this.visible = false;
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; });
      this.io.observe(this);
      this.addEventListener('pointerenter', () => { this.paused = true; });
      this.addEventListener('pointerleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });
      this.track.addEventListener('touchstart', () => { clearInterval(this.timer); }, { passive: true, once: true });
      this.timer = setInterval(() => {
        if (this.paused || !this.visible || document.hidden || !this.isSlider()) return;
        this.go(1, true);
      }, ms);
    }
  }
  customElements.define('hy-grids', HyGrids);

  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest && e.target.closest('[data-item]');
    const track = item && item.closest('[data-track]');
    if (track) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
